
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/escalated-complaints",
      function () {
        return require("private-next-pages/escalated-complaints/index.page.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/escalated-complaints"])
      });
    }
  